import ConfigValue from '../ConfigValue/ConfigValue'
import { CONFIG_KEYS } from '../../constants'

export default function LoginTitle() {
  console.log('LoginTitle rendered')

  return (
    <h1 style={{ paddingTop: '5px', marginBottom: '0px', fontSize: '24px', fontWeight: '300', letterSpacing: '-0.5px' }} data-cy="login-title">
      <ConfigValue configKey={CONFIG_KEYS.loginTitleText.key} defaultValue={CONFIG_KEYS.loginTitleText.defaultValue} />
    </h1>
  )
}
